"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.consentElementsToTextFields = consentElementsToTextFields;
const signer_roles_1 = require("./signer_roles");
/** Editor stores geometry as fractions of the page (0–1). Template `form.json` uses CSS percentages (0–100). */
function fractionToCssPercent(fraction) {
    return Math.round(fraction * 10000) / 100;
}
/**
 * Maps TEXT_INPUT elements to `textFields` for `templates.consent.framework.app~1_0`.
 *
 * Emitted in the order the fields are printed — by page, then down the page, then across it — because
 * the overlays are absolutely positioned, so keyboard and screen-reader order follows the order the host
 * mounts them in, not their visual position. Same reasoning as {@link consentElementsToDateFields}.
 *
 * `ec__key` correlates back to `ec__requested_data[].ec__key`, which is what the host submits to Cortex's
 * `set_data` as `ec__identifier` with the type the author chose (`ec__text` / `ec__numeric` / `ec__email`).
 *
 * `label` is the author's Label field, carried so the field has an accessible name; it is never
 * drawn on the overlay. `placeholder` is the author's Placeholder only — empty when they left it
 * blank, never the Label. Both are document text in the document's language, not routed through
 * the translation pipeline.
 *
 * Lives here rather than in the editor because the Firebase `consent_bundler` owns compilation while the
 * editor owns authoring — both need the identical wire shape.
 *
 * @param createError builds the thrown error, so `consent_bundler` can surface a 400 `ServiceError`
 *   while other callers get a plain `Error`.
 */
function consentElementsToTextFields(elements, roles = [], createError = (message) => new Error(message)) {
    return elements
        .filter((el) => el.type === 'TEXT_INPUT')
        .sort((a, b) => a.page - b.page || a.position.yPct - b.position.yPct || a.position.xPct - b.position.xPct)
        .map((el) => {
        var _a, _b, _c, _d, _e, _f, _g;
        if (typeof el.config.ec__key !== 'string' || el.config.ec__key.length === 0) {
            throw createError(`Consent bundler: text element is missing ec__key (role=${(_a = el.config.ec__signer_role) !== null && _a !== void 0 ? _a : ''}). Every text field must have a stable ec__key so the host can correlate the entered value to ec__requested_data.`);
        }
        return {
            ec__key: el.config.ec__key,
            page: el.page,
            xPct: fractionToCssPercent(el.position.xPct),
            yPct: fractionToCssPercent(el.position.yPct),
            widthPct: fractionToCssPercent(el.position.widthPct),
            heightPct: fractionToCssPercent(el.position.heightPct),
            signerType: (_c = (_b = (0, signer_roles_1.findRoleByLabel)(el.config.ec__signer_role, roles)) === null || _b === void 0 ? void 0 : _b.signerTypeId) !== null && _c !== void 0 ? _c : 'participant',
            role: (0, signer_roles_1.getSignerRoleLabel)(el.config.ec__signer_role),
            optional: (_d = el.config.ec__optional) !== null && _d !== void 0 ? _d : false,
            label: (_e = el.config.ec__label) !== null && _e !== void 0 ? _e : '',
            placeholder: (_g = (_f = el.config.ec__placeholder) === null || _f === void 0 ? void 0 : _f.trim()) !== null && _g !== void 0 ? _g : '',
            inputType: el.config.ec__input_type,
        };
    });
}
//# sourceMappingURL=text_fields.js.map